import { render, staticRenderFns } from "./GroupViewInfo.vue?vue&type=template&id=9c1f71d4&scoped=true&"
import script from "./GroupViewInfo.vue?vue&type=script&lang=js&"
export * from "./GroupViewInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupViewInfo.vue?vue&type=style&index=0&id=9c1f71d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f71d4",
  null
  
)

export default component.exports